import { useCallback, useEffect, useState } from 'react'
import { errorMessage, LeadFormsApi, Stats } from './api'

/** Ignore responses from an earlier website, form or date range. */
export const useLeadFormStats = (
	api: LeadFormsApi | undefined,
	days: 7 | 30,
	formId?: string,
	refreshKey?: unknown
) => {
	const [result, setResult] = useState<{
		stats: Stats | null
		loading: boolean
		error: string | null
	}>({ stats: null, loading: !!api, error: null })
	const [revision, setRevision] = useState(0)
	const refresh = useCallback(() => setRevision((value) => value + 1), [])
	useEffect(() => {
		let active = true
		if (!api) {
			setResult({ stats: null, loading: false, error: null })
			return
		}
		setResult({ stats: null, loading: true, error: null })
		api.stats(days, formId).then(
			(stats) => {
				if (active) setResult({ stats, loading: false, error: null })
			},
			(error) => {
				if (active)
					setResult({ stats: null, loading: false, error: errorMessage(error) })
			}
		)
		return () => {
			active = false
		}
	}, [api, days, formId, refreshKey, revision])
	return { ...result, refresh }
}
